import Factory from '../utils/factory'

export default Factory({
  id: null,
  overrides: {
    pricing: null,
  },
  selected: false,
  isDefault: false,
  product: null,
  sets: [],
  quantity: {
    enabled: false,
    min: 1,
    max: null,
  },
  referencePropertyChanges: [],
  variant: null,
  acceptInquiries: false,
  conditions: {
    if: [],
    ifnot: [],
  },
})
